import { ENDPOINTS, MIDDLEWARE } from "./api-endpoints";
import { extractBaseServer, extractDomain } from "../utils";

export default async function getHeaderData() {
  let url, host;
  if (typeof window !== "undefined") {
    url = window.location.pathname;
    host = window.location.host;
  }

  try {
    const queryParams = new URLSearchParams({
      currentUrlEndpoint: url,
    });

    const response = await fetch(
      `${MIDDLEWARE}${ENDPOINTS.getHeader}?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          baseserver: extractBaseServer(host),
          domain: extractDomain(),
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && data.ADDITIONAL) {
      sessionStorage.setItem("userdetails", JSON.stringify(data.ADDITIONAL));
    }

    return data;
  } catch (error) {
    console.error("Error fetching header data:", error);
    return null;
  }
}
